import { usePageContext } from "vike-react/usePageContext";
import { useEffect, useState } from "react";
import { MotifBand, motifLabel } from "../../components/Motifs.js";
import { langCodeToName } from "../../utils/appTheme.js";
import { PhrasePractice } from "../../components/PhrasePractice.js";
import { ComingSoon } from "../../components/ComingSoon.js";

const C = {
  bg: 'var(--bg)', surf: 'var(--surf)', surf2: 'var(--surf2)',
  border: 'var(--border)', text: 'var(--text)', muted: 'var(--muted)', dim: 'var(--dim)',
  accentBg: 'var(--accent-bg)', accentBorder: 'var(--accent-border)',
};
const AF = {
  h: 'var(--font-h, "Space Grotesk", system-ui, sans-serif)',
  b: "'DM Sans', system-ui, sans-serif",
  m: "'DM Mono', 'Courier New', monospace",
};

export default function Page() {
  const pageContext = usePageContext();
  const langCode = pageContext.routeParams?.language ?? 'es';
  const comingSoon = pageContext.routeParams?.comingSoon === 'true';
  const language = langCodeToName(langCode);

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  if (comingSoon) return <ComingSoon language={langCode} />;

  const hp = isMobile ? '16px' : '48px';
  const hasPhrases = ['es', 'pt', 'fi'].includes(langCode);

  return (
    <div style={{ flex: 1, overflowY: 'auto', background: C.bg }}>
      {/* Motif header */}
      <div style={{
        position: 'relative', overflow: 'hidden',
        borderBottom: `1px solid ${C.border}`,
      }}>
        <div style={{
          position: 'absolute', inset: 0, opacity: 0.55,
          WebkitMaskImage: 'linear-gradient(to left, #000, transparent 60%)',
          maskImage: 'linear-gradient(to left, #000, transparent 60%)',
        }}>
          <MotifBand language={language} height={isMobile ? 96 : 112} opacity={0.7}/>
        </div>
        <div style={{ position: 'relative', padding: `22px ${hp} 18px` }}>
          <div style={{ fontFamily: AF.m, fontSize: 10, color: 'var(--accent)', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 8 }}>
            {motifLabel(language)}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
            <span style={{ fontSize: 18, lineHeight: 1 }}>🗣️</span>
            <h1 style={{ fontFamily: AF.h, fontSize: isMobile ? 22 : 26, fontWeight: 700, color: C.text, margin: 0, letterSpacing: '-0.7px' }}>
              Speaking
            </h1>
          </div>
          <p style={{ fontFamily: AF.b, fontSize: 13, color: C.muted, margin: 0 }}>
            Drill essential phrases until they come naturally.
          </p>
        </div>
      </div>

      <div style={{ padding: `28px ${hp}` }}>
        {hasPhrases ? (
          <PhrasePractice languageCode={langCode} />
        ) : (
          <div style={{ textAlign: 'center', padding: '64px 0' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>🗣️</div>
            <p style={{ fontFamily: AF.b, fontSize: 15, color: C.muted }}>
              Phrase practice coming soon for {language}.
            </p>
          </div>
        )}

        {/* Tutor CTA */}
        <div style={{ marginTop: 40, paddingTop: 28, borderTop: `1px solid ${C.border}` }}>
          <div style={{ fontFamily: AF.m, fontSize: 9, color: C.dim, letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 14 }}>
            Ready for real conversations?
          </div>
          <a
            href="https://www.tusclasesparticulares.cl/profesores/cynthia-valenzuela-osorio.htm"
            target="_blank" rel="noopener noreferrer follow index"
            style={{ textDecoration: 'none', display: 'inline-flex' }}
          >
            <div style={{
              display: 'flex', alignItems: 'center', gap: 14,
              padding: '14px 18px', borderRadius: 10,
              background: C.surf, border: `1px solid ${C.border}`,
              transition: 'border-color 0.15s',
            }}>
              <div style={{
                width: 40, height: 40, borderRadius: '50%', flexShrink: 0,
                background: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontFamily: AF.b, fontSize: 12, fontWeight: 700, color: C.bg,
              }}>CV</div>
              <div>
                <div style={{ fontFamily: AF.b, fontSize: 14, fontWeight: 600, color: C.text, marginBottom: 2 }}>
                  Book a lesson with Cynthia
                </div>
                <div style={{ fontFamily: AF.b, fontSize: 12, color: C.muted }}>
                  Native teacher · First class free
                </div>
              </div>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ marginLeft: 8, flexShrink: 0 }}>
                <path d="M3 8h10M9 4l4 4-4 4" stroke="var(--accent)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
